import { render, staticRenderFns } from "./color-management.vue?vue&type=template&id=1895d7f8&scoped=true"
import script from "./color-management.vue?vue&type=script&lang=ts"
export * from "./color-management.vue?vue&type=script&lang=ts"
import style0 from "./color-management.vue?vue&type=style&index=0&id=1895d7f8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1895d7f8",
  null
  
)

export default component.exports